import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { AboutService } from './components/AboutService';
import { Services } from './components/Services';
import { Performance } from './components/Performance';
import { Methodology } from './components/Methodology';
import { WhyWorkWithMe } from './components/WhyWorkWithMe';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
function App() {
  return <div className="min-h-screen bg-white font-sans text-slate-900 selection:bg-blue-100 selection:text-blue-900" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <AboutService data-id="element-4" />
        <Services data-id="element-5" />
        <Performance data-id="element-6" />
        <Methodology data-id="element-7" />
        <WhyWorkWithMe data-id="element-8" />
        <FinalCTA data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}
export { App };